export default __webpack_public_path__ + "static/media/options.286a0375.svg";